var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "vueForm vueFormStep fallbackForm",
      attrs: {
        action:
          "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8",
        method: "POST"
      },
      on: {
        submit: function($event) {
          return _vm.formSubmit($event)
        }
      }
    },
    [
      _vm.showHeaders === "true"
        ? _c("header", [
            _c("h5", { staticClass: "vueForm__header font__color--orange" }, [
              _vm._v("Thanks for your interest in ShopKeep!")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "vueForm__subheader font__color--steel" }, [
              _vm._v(
                "Just tell us the best way to reach you. We'll take it from there."
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vueForm__fields" }, [
      _c("input", {
        attrs: { type: "hidden", name: "oid", value: "00D80000000PNFh" }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: {
          type: "hidden",
          name: "Lead_Source_Notes__c",
          value: "Inbound Lead Backup Form"
        }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: {
          type: "hidden",
          name: "retURL",
          value: "https://www.shopkeep.com/thank-you-confirmation"
        }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: {
          placeholder: "First Name",
          id: "first_name",
          maxlength: "40",
          name: "first_name",
          size: "20",
          type: "text",
          autofocus: ""
        }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: {
          placeholder: "Last Name",
          id: "last_name",
          maxlength: "80",
          name: "last_name",
          size: "20",
          type: "text",
          required: ""
        }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: {
          placeholder: "Business Name",
          id: "company",
          maxlength: "40",
          name: "company",
          size: "20",
          type: "text",
          required: ""
        }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: {
          placeholder: "Phone Number",
          id: "phone",
          maxlength: "40",
          name: "phone",
          size: "20",
          type: "text",
          required: ""
        }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: {
          placeholder: "Business Email",
          id: "email",
          maxlength: "80",
          name: "email",
          size: "20",
          type: "email",
          pattern: "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+[^.]\\.[A-Za-z]{2,}$",
          required: ""
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        { attrs: { type: "submit", name: "submit", value: "submit" } },
        [_vm._v("Get my free quote")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }